export default "/assets/images/home-wrecker2.e8e8435e6b7483d1.png";